// Shared inbox notification type metadata + relative-time helper.
// Used by InboxPopover (Topbar bell) and the full Notification Log page.
import {
  AlertOctagon,
  AlertTriangle,
  MessageSquare,
  UserPlus,
  CheckCircle2,
  ClipboardList,
  Mail,
  Smartphone,
  Inbox as InboxIcon,
} from "lucide-react";

export const NOTIF_TYPE_META = {
  SLA_BREACH: { Icon: AlertOctagon, color: "#E24B4A", label: "SLA Breach", group: "sla" },
  SLA_WARNING: { Icon: AlertTriangle, color: "#f3b14a", label: "SLA Warning", group: "sla" },
  MENTION: { Icon: MessageSquare, color: "#9ec3ec", label: "Mention", group: "mention" },
  ASSIGNED: { Icon: UserPlus, color: "#c89adb", label: "Assigned", group: "assigned" },
  APPROVAL_NEEDED: { Icon: CheckCircle2, color: "#4ed084", label: "Approval needed", group: "approval" },
  "8D_ACTION_NEEDED": { Icon: ClipboardList, color: "#9ec3ec", label: "8D action", group: "approval" },
  SERVICE_REQUEST_CREATED: { Icon: ClipboardList, color: "#f3b14a", label: "Service request", group: "sr" },
  SERVICE_REQUEST_UPDATED: { Icon: ClipboardList, color: "#9ec3ec", label: "Service request updated", group: "sr" },
  EMAIL_SENT: { Icon: Mail, color: "#5ea3e3", label: "Email sent", group: "email" },
  SMS_SENT: { Icon: Smartphone, color: "#c89adb", label: "SMS sent", group: "sms" },
};

export const DEFAULT_META = { Icon: InboxIcon, color: "#9198b0", label: "Notification", group: "other" };

export const metaFor = (type) => NOTIF_TYPE_META[type] || DEFAULT_META;

export const relativeTime = (iso) => {
  if (!iso) return "";
  try {
    const then = new Date(iso);
    const diffMs = Date.now() - then.getTime();
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return "just now";
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const d = Math.floor(hr / 24);
    if (d < 7) return `${d}d ago`;
    return then.toLocaleDateString();
  } catch {
    return "";
  }
};
